import React from 'react';
import * as S from './RewardProgressTable.styles';
import MypProgressBar from '../MypProgressBar/MypProgressBar';
import classnames from 'classnames';

const RewardProgressTable = ({header, data, info}) => {
  return (
    <S.RewrdProgressTableContainer>
      {info && Object.keys(info)?.length ? (
        <div className=" makeRelative minHeight300">
          <div className="mypTblBackdrop">
            <p className="font18 lineHeight20 primaryTxtWhite appendBottom22 latoBlack">
              {info?.primaryText || ''}
            </p>
            <button
              className="backdropMyp largeActnBtn"
              onClick={() => {
                window.open(info?.btnURL, '_self');
              }}
            >
              {info?.btnText}
            </button>
          </div>
        </div>
      ) : (
        <div className="tableBrdr">
          {' '}
          <div className="makeFlex blackBg tHeaderRadius">
            {header?.map(heading => {
              return (
                <div
                  key={heading?.primaryText}
                  className={classnames(heading?.style?.customClasses)}
                >
                  <span>{heading?.primaryText}</span>
                </div>
              );
            })}
          </div>
          <div className="makeFlex">
            <div className="flexOne">
              {data.map((item, index) => (
                <div key={index} className="progressTableRow">
                  <div className="td1 makeFlex vrtlCenter width174">
                    <p className="makeFlex dirColumn">
                      <p className="font14 lineHeight20 latoBlack appendBottom4">
                        {item?.scheme?.primaryText}
                      </p>
                      <p className="font12 lineHeight16 latoBold tertiaryTxt">
                        {' '}
                        {item?.scheme?.secondaryText}
                      </p>
                    </p>
                  </div>
                  <div className="td1 makeFlex vrtlCenter width332">
                    <span className={classnames(item?.incentiveTarget?.icon?.iconClasses)}></span>
                    <p className="makeFlex dirColumn">
                      <span className="latoBold font18 lineHeight28">
                        {item?.incentiveTarget?.primaryText}
                      </span>
                      <span className="font16 lineHeight24">
                        {item?.incentiveTarget?.secondaryText}
                      </span>
                    </p>
                  </div>
                  <MypProgressBar data={item?.currentStatus} />
                  <div className="td3">
                    <span className="font14 lineHeight20 latoBold">
                      {item?.reward?.primaryText}
                    </span>
                    {item?.reward?.show_lock ? (
                      <div className={`cashBack ${item?.reward?.isLocked ? 'Lock' : 'Unlock'}`}>
                        <span
                          className={`${
                            item?.reward?.isLocked
                              ? 'mypSprite ic_rewardLock'
                              : 'mypSprite ic_rewardUnlock'
                          }`}
                        ></span>
                        <span
                          className={`font12 lineHeight16 latoBlack tertiaryTxt appendLeft6 ${
                            item?.reward?.isLocked ? 'tertiaryTxt' : 'mypBrownText'
                          }`}
                        >
                          {item?.reward?.secondaryText}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </S.RewrdProgressTableContainer>
  );
};

export default RewardProgressTable;
